import { render, staticRenderFns } from "./View.vue?vue&type=template&id=44be7436&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44be7436",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44be7436')) {
      api.createRecord('44be7436', component.options)
    } else {
      api.reload('44be7436', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=44be7436&scoped=true", function () {
      api.rerender('44be7436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Post/View.vue"
export default component.exports